module.exports = __webpack_public_path__ + "assets/media/pay.0f6898ad.mp3";